/* PROJ-99 — Gemeinsamer Bearbeiten-Baustein der SCHMUCK-Editoren
 * ==============================================================
 * Gegenstueck zu assets/cart-edit.js (dem editor-unabhaengigen Helfer): dort liegt der
 * Warenkorb-Teil (Zeile finden, `_config_json` lesen, Knopftext, alte Zeile entfernen),
 * hier liegt alles, was in JEDEM Schmuck-Editor gleich ist:
 *
 *   1. Modus-Erkennung am `edit`-Parameter          -> istModus
 *   2. Warten auf `DLCartEdit.bereit`               -> starten()
 *   3. Produkt-/Versionspruefung + Hinweis          -> starten()
 *   4. „Einige Angaben ..."-Hinweis bei Luecken     -> starten()
 *   5. Kachel setzen ueber ein data-Attribut        -> kachelSetzen()
 *   6. CSS.escape-Ersatz fuer Selektorwerte         -> selektorWert()
 *   7. Ladesperre am Warenkorb-Knopf (I1)           -> knopfSperren()
 *
 * Editor-spezifisch bleibt NUR die Feld-Abbildung (die `anwenden`-Funktion). Deshalb ist
 * diese Datei ein klassisches Skript (kein Modul): die Sections laden sie VOR dem
 * Editor-Modul, der sie dann als `window.DLJewelryBearbeiten` vorfindet.
 *
 * Warum die Modus-Erkennung am PARAMETER haengt und nicht an `window.DLCartEdit`:
 * der Helfer schaltet sich bei einer verschwundenen Zeile asynchron wieder ab, die Editoren
 * lesen `istModus` aber schon beim Laden (fuer die Preset-Sperre). Ein Objekt-Check waere
 * zeitabhaengig. `?edit=` ohne Wert und ein spaeter abgeschalteter Modus gelten damit als
 * Bearbeiten-Modus -> neutraler Editor ohne Presets. Gewollt: wer aus dem Warenkorb kommt,
 * soll im Zweifel seinen eigenen Stand sehen, nicht die Kampagne.
 *
 * Diese Datei feuert NIE `cart:change` (PROJ-96-Falle) und fasst den Warenkorb nicht an.
 */
(function () {
	'use strict';

	/* ---------------------------------------------------------------- Texte */

	/* Der einzige fest verdrahtete Text des Schmuck-Bearbeiten-Modus. Bewusst hier und nicht
	   zehnmal in den Editoren — genau darum gibt es diese Datei. Es ist eine Stoerungsmeldung,
	   kein Shop-Text mit Theme-Einstellung (gleiche Begruendung wie in cart-edit.js). */
	var HINWEIS_TEILWEISE = 'Einige Angaben konnten nicht übernommen werden.';
	/* Der Text fuer „Zeile gehoert zu einem anderen Produkt" stand frueher HIER — und ein
	   zweites Mal, anders formuliert, in citymap.js/starmap-celestial.js (dort hiess derselbe
	   Fall „Einige Angaben konnten nicht übernommen werden"). Seit der Final-Fix-Welle (I4)
	   gehoert er cart-edit.js: DLCartEdit.HINWEIS_ANDERES_PRODUKT. Er wird unten LAZY gelesen,
	   nicht hier oben — diese Datei laedt die Section vor dem deferred cart-edit.js, zum
	   Zeitpunkt der Modul-Auswertung gibt es window.DLCartEdit also noch gar nicht. */

	/* ---------------------------------------------------------------- Modus */

	/* Dieselbe Quelle wie in allen Editoren (PROJ-44): das Inline-Skript der Section merged
	   preset_params und echte URL-Parameter nach window.DLEditorSearch. */
	var parameter = new URLSearchParams(window.DLEditorSearch || window.location.search);
	var IST_MODUS = parameter.get('edit') !== null;

	/* ---------------------------------------------------------------- Selektoren */

	/* Config-Werte landen in Attribut-Selektoren (data-farbe, data-symbol, data-stil ...).
	   Ein Anfuehrungszeichen oder Backslash darin wuerde den Selektor sprengen — und da die
	   Werte aus einer Warenkorbzeile kommen, ist das nichts, was man dem Zufall ueberlaesst.
	   CSS.escape gibt es seit Jahren ueberall; der Ersatz ist nur die Absicherung fuer sehr
	   alte Browser (gleiche Loesung wie dlSelektorWert in citymap.js/starmap-celestial.js). */
	function selektorWert(wert) {
		var text = String(wert == null ? '' : wert);
		if (typeof CSS !== 'undefined' && CSS && typeof CSS.escape === 'function') return CSS.escape(text);
		return text.replace(/["'\\\]\[\(\):;,.#>+~*=^$|\s]/g, function (z) { return '\\' + z; });
	}

	/* Setzt die Kachel mit <attribut>="<wert>" auf `current` und raeumt die Geschwister ab —
	   also genau das, was der Klick-Handler des Kunden tut, nur ohne Klick (ein Klick wuerde
	   in diesen Editoren zusaetzlich neu rendern, und das passiert am Ende gebuendelt).
	   `wurzel` ist der Editor-Wrapper oder ein einzelnes Feld (Buchstaben-Coin).
	   Rueckgabe: true, wenn eine Kachel getroffen wurde. Gibt es die Kachelgruppe im Markup
	   gar nicht (z. B. keine Farb-Swatches beim Schluesselanhaenger), gilt das NICHT als
	   Fehler — dann ist an der Oberflaeche schlicht nichts zu zeigen. */
	function kachelSetzen(wurzel, klasse, attribut, wert) {
		if (!wurzel) return false;
		var alle = wurzel.querySelectorAll(klasse + '[' + attribut + ']');
		if (!alle.length) return true;
		var treffer = wurzel.querySelector(klasse + '[' + attribut + '="' + selektorWert(wert) + '"]');
		if (!treffer) return false;
		for (var i = 0; i < alle.length; i++) alle[i].classList.remove('current');
		treffer.classList.add('current');
		return true;
	}

	/* Eingabefeld setzen. Rueckgabe false, wenn es das Feld nicht gibt — dann fehlt im Markup
	   etwas, und der Kunde soll den Hinweis sehen statt still einen leeren Editor. */
	function feldSetzen(id, wert) {
		var el = document.getElementById(id);
		if (!el) return false;
		el.value = wert == null ? '' : String(wert);
		return true;
	}

	/* ---------------------------------------------------------------- Knopf-Ladesperre */

	/* PROJ-99 (I1). Jeder Schmuck-Editor ruft das als ERSTES — noch bevor er Presets liest,
	   Gravuren rechnet und die 3D-Buehne aufbaut. Bis `starten()` den Warenkorb-Zustand
	   wirklich angewendet hat, vergeht Zeit, und ein Klick auf „In den Warenkorb" in dieser
	   Zeit legte den DEFAULT-Stand ein. Die eigentliche Sperre (Text, aria, pointer-events und
	   die Flagge fuer programmatische Klicks) liegt in cart-edit.js; hier steht nur die
	   Weiche, damit keiner der zehn Editoren die Modus- und Null-Pruefungen kopieren muss.

	   Aufgehoben wird die Sperre an genau drei Stellen: knopfAnpassen() (Zustand steht),
	   knopfFreigeben() in `starten()` (Zeile passt nicht zum Produkt) und knopfFreigeben() in
	   cart-edit.js selbst (Zeile weg, Config nicht lesbar). */
	function knopfSperren(knopf) {
		if (!IST_MODUS) return false;
		var helfer = window.DLCartEdit;
		if (!helfer) return false;
		helfer.knopfSperren(knopf);
		return true;
	}

	/* ---------------------------------------------------------------- Start */

	/* optionen = {
	 *   name:     'jewelry-tag'                 fuer Konsolenmeldungen
	 *   produkt:  'papa-anhaenger'              MUSS config.produkt sein
	 *   version:  1                             MUSS config.version sein
	 *   passt:    function (config) -> null | 'Grund'   optional, zusaetzliche Produktprobe
	 *   anwenden: function (config) -> { angewendet: [], fehlend: [] }   (darf async sein)
	 *   knopf:    HTMLElement                   der ECHTE Warenkorb-Knopf des Editors
	 * }
	 * Rueckgabe: Promise<boolean> — true heisst „Bearbeiten-Modus laeuft, der naechste
	 * Warenkorb-Klick ersetzt die alte Zeile".
	 */
	async function starten(optionen) {
		if (!IST_MODUS) return false;

		/* Referenz festhalten: der Helfer setzt window.DLCartEdit im Fehlerfall auf null,
		   das Promise `bereit` bleibt aber an diesem Objekt haengen. */
		var helfer = window.DLCartEdit;
		if (!helfer) return false;

		var config = await helfer.bereit;
		/* Zeile weg oder `_config_json` kaputt: der Helfer hat abgeschaltet und seinen eigenen
		   Hinweis gezeigt — hier bleibt nichts zu tun, der Editor ist ein normaler Editor. */
		if (!config) return false;
		if (!window.DLCartEdit) return false;

		var grund = null;
		if (config.produkt !== optionen.produkt) {
			grund = 'produkt="' + config.produkt + '" statt "' + optionen.produkt + '"';
		} else if (config.version !== optionen.version) {
			grund = 'version=' + JSON.stringify(config.version) + ' statt ' + JSON.stringify(optionen.version);
		} else if (typeof optionen.passt === 'function') {
			grund = optionen.passt(config);
		}
		if (grund) {
			/* Lieber gar nicht anwenden als ein fremdes Motiv ueberschreiben: die Zeile gehoert
			   zu einem anderen Produkt (oder zu einem aelteren Config-Format, das diese Fassung
			   nicht mehr kennt). Modus aus, Editor bleibt frei bedienbar, die alte Zeile bleibt
			   unangetastet im Warenkorb. */
			console.warn('[PROJ-99] ' + optionen.name + ': Warenkorbzeile passt nicht (' + grund + ') — Bearbeiten-Modus aus.');
			helfer.hinweis(helfer.HINWEIS_ANDERES_PRODUKT);
			/* I1: erst den Knopf aus der Ladesperre holen, dann den Modus abschalten — danach
			   ist der Helfer ueber window.DLCartEdit nicht mehr erreichbar. */
			helfer.knopfFreigeben();
			window.DLCartEdit = null;
			window.__dlBearbeitenErgebnis = { ok: false, grund: grund };
			return false;
		}

		var ergebnis;
		try {
			ergebnis = await optionen.anwenden(config);
		} catch (e) {
			/* Ein Fehler beim Anwenden darf den Editor nicht lahmlegen — er bleibt bedienbar,
			   nur eben mit dem, was schon gesetzt wurde. */
			console.error('[PROJ-99] ' + optionen.name + ': Bearbeiten-Modus konnte nicht vollstaendig hergestellt werden:', e);
			ergebnis = { angewendet: [], fehlend: ['ausnahme'] };
		}
		if (!ergebnis) ergebnis = { angewendet: [], fehlend: [] };
		if (!Array.isArray(ergebnis.fehlend)) ergebnis.fehlend = [];
		if (!Array.isArray(ergebnis.angewendet)) ergebnis.angewendet = [];

		if (ergebnis.fehlend.length) {
			console.warn('[PROJ-99] ' + optionen.name + ': nicht uebernommen:', ergebnis.fehlend.join(', '));
			helfer.hinweis(HINWEIS_TEILWEISE);
		}

		helfer.knopfAnpassen(optionen.knopf);
		/* Testnaht (gleiches Muster wie citymap.js/starmap-celestial.js): der Harness wartet
		   darauf, statt blind eine Zeitspanne abzusitzen. */
		window.__dlBearbeitenErgebnis = { ok: true, ausConfig: ergebnis };
		return true;
	}

	window.DLJewelryBearbeiten = {
		istModus: IST_MODUS,
		HINWEIS_TEILWEISE: HINWEIS_TEILWEISE,
		knopfSperren: knopfSperren,
		selektorWert: selektorWert,
		kachelSetzen: kachelSetzen,
		feldSetzen: feldSetzen,
		starten: starten
	};
})();
